import React from 'react';
import PropTypes from 'prop-types';

import styles from './Tiles.module.css';
import Link from './Link';

const Tiles = ({ entries }) => {
  return (
    <span>
      <div className={styles.flex}>
        <Link className={styles.header} name="referenzen" tag="h2" />
        <div className={styles.grid}>
          {entries.map(({ image, title, text }, i) => {
            return (
              <div key={`${title}_${i}`} className={styles.tile}>
                <div className={styles.image} style={{ backgroundImage: image ? `url(${image.file.url})` : undefined }} />
                <span className={styles.animateText}>
                  <h4>{title}</h4>
                  {text ? <h4>{text.text}</h4> : null}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </span>
  );
};

Tiles.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
      title: PropTypes.string.isRequired,
      text: PropTypes.shape({
        text: PropTypes.string,
      }),
    })
  ).isRequired,
};

export default Tiles;



// WEBPACK FOOTER //
// ./src/components/Tiles.js